import { atomWithStorage } from 'jotai/utils';
import { initialStateProfile } from './initialState';
import { UserDTO } from '@twygs/shared/publisher-interface';
import Cookies from 'js-cookie';
import { removeAllCookies } from 'src/constants';

const getUserFromLocal = (): UserDTO => {
  try {
    const token = Cookies.get(`token`);
    if (!token) {
      removeAllCookies();
      return initialStateProfile as unknown as UserDTO;
    }

    const storedValue = localStorage.getItem('user');
    if (!storedValue) {
      return initialStateProfile as unknown as UserDTO;
    }

    const parsed = JSON.parse(storedValue);
    return (parsed ?? initialStateProfile) as UserDTO;
  } catch (_error) {
    return initialStateProfile as unknown as UserDTO;
  }
};

export const profileAtom = atomWithStorage<UserDTO>('user', getUserFromLocal());
